import { BreederAffiliation } from 'shared/@types';

function getBreederAffiliation(
  affiliation: BreederAffiliation | null | undefined,
): BreederAffiliation {
  return affiliation ?? BreederAffiliation.IndependentBreeder;
}

export { getBreederAffiliation };
